const day = value => {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date);
    const get = type => Number(parts.find(part => part.type === type).value);
    return Date.UTC(get('year'), get('month') - 1, get('day'));
};
export function formatTournamentDate(value) {
    return day(value) === null ? 'Termin nieustalony' : new Date(value).toLocaleDateString('pl-PL', { timeZone: 'Europe/Warsaw', day: 'numeric', month: 'short', year: 'numeric' });
}
export function tournamentDuration(start, end) {
    const first = day(start), last = day(end);
    if (first === null || last === null || last < first) return null;
    return Math.round((last - first) / 86400000) + 1;
}
export function normalizeTournaments(data) {
    if (!Array.isArray(data)) throw new Error('Nieprawidłowa lista turniejów.');
    const tournaments = new Map();
    for (const row of data) {
        const id = Number(row?.id ?? row?.tournamentId), name = row?.name ?? row?.tournamentName;
        if (!Number.isSafeInteger(id) || id < 1 || typeof name !== 'string') throw new Error('Brak poprawnego ID lub nazwy turnieju.');
        if (!tournaments.has(id)) tournaments.set(id, { id, name, startDate: row.startDate, endDate: row.endDate, teams: [] });
        const item = tournaments.get(id);
        const teamId = Number(row.teamId);
        if (Number.isSafeInteger(teamId) && teamId > 0 && !item.teams.some(team => team.id === teamId)) item.teams.push({ id: teamId, name: row.teamName || `Drużyna #${teamId}` });
    }
    return [...tournaments.values()];
}
